import React, { useState, useEffect } from "react";
import placeHolder from "../../../assets/images/placeHolder.png";
import unavailable from "../../../assets/images/price_unavailable.png";
import quantity from "../../../assets/images/min_not_met.png";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import Stack from "@mui/material/Stack";

export default function ProductGalleryViewer(props) {
  const [selectedImage, setSelectedImage] = useState(placeHolder);
  const [images, setImages] = useState([]);
  const errorImage =
    props.errorType === "product"
      ? unavailable
      : "generalError"
      ? placeHolder
      : quantity;

  useEffect(() => {
    setImages(props.images);
    props.baring
      ? setSelectedImage(props.images[1])
      : setSelectedImage(props.images[0]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.images]);

  return (
    <Stack justifyContent="center" alignItems="center">
      <Mobile>
        <img
          src={selectedImage}
          onError={(e) => {
            e.target.src = placeHolder;
          }}
          alt="Selected Product"
          className="selected-product"
        />
        <Stack
          direction="row"
          spacing={5}
          justifyContent="center"
          alignItems="center"
        >
          {images &&
            images.length > 1 &&
            images.map((image) => (
              <img
                key={image.toString()}
                src={image}
                className="detail-imgs"
                alt="Mini Product"
                onError={(e) => {
                  e.target.src = placeHolder;
                }}
                onClick={() => setSelectedImage(image)}
              />
            ))}
        </Stack>
      </Mobile>
      <Default>
        <img
          src={props.error ? errorImage : selectedImage}
          onError={(e) => {
            e.target.src = placeHolder;
          }}
          alt="Selected Product"
          className="selected-product"
        />
        <Stack direction="row" spacing={12}>
          {!props.error &&
            images &&
            images.length > 1 &&
            images.map((image) => (
              <img
                key={image.toString()}
                src={image}
                className="detail-imgs"
                alt="Mini Product"
                onError={(e) => {
                  e.target.src = placeHolder;
                }}
                onClick={() => setSelectedImage(image)}
              />
            ))}
        </Stack>
      </Default>
    </Stack>
  );
}
